module.exports = __webpack_public_path__ + "static/media/logo.d12829e5.png";